import { API } from "@aws-amplify/api";

export const getValuation = `query ($input:getValuationInput){
    getValuation(input:$input)
    }`;

export async function getValuationDetails(customerId: any): Promise<any> {
    try {

        const response: any = await API.graphql({ query: getValuation, variables: { input: { customerId: customerId } } });
        return response.data.getValuation;
    } catch (error) {
        console.log("getValuation", error);
    }
}

export const getValuationDeclarationQuery = `query($input: getValDeclareInput) {
    getValuationDeclaration(input:$input)
    }`;

export async function getValuationDeclaration(params: any): Promise<any> {
    try {

        const response: any = await API.graphql({ query: getValuationDeclarationQuery, variables: { input: { customerId: params.customerId, optionInput: params.optionInput } } });
        return response.data.getValuationDeclaration;
    } catch (error) {
        console.log("getValuationDeclaration", error);
    }
}

export const calculatePremium = `mutation ($input: calcValuationInput) {
    calOptValuationDetails(input: $input) {
    deductibleId
    footerText
    premium
    title
    }
    }`;

export async function getCalculatePremium(params: any): Promise<any> {
    try {

        const response: any = await API.graphql({ query: calculatePremium, variables: { input: { customerId: params.customerId, declaredValue: params.declaredValue } } });
        return response.data.calOptValuationDetails;
    } catch (error) {
        console.log("getValuation", error);
    }
}


export const updateValuation = `mutation($input:  updateValuationInput) {
    updateValuation(input: $input) {
    customerId
    declaredValue
    optionId
    deductableId
    }
    }`;

export async function callUpdateValuation(params: any): Promise<any> {
    try {

        const response: any = await API.graphql(
            {
                query: updateValuation,
                variables: {
                    input:
                    {
                        customerId: params.customerId,
                        declaredValue: params.declaredValue,
                        optionId: params.optionId,
                        deductableId: params.deductableId
                    }
                }
            });
        return response.data.updateValuation;
    } catch (error) {
        console.log("getValuation", error);
    }
}


